<template>
  <div class="dropdown-center">
    <button
      id="dropdowLeaseItNowFilterFuel"
      class="form-select form-select-multiselect"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      <div v-if="selected.length" class="form-select-wrapper">
        <div>
          <ul class="b-options-badges">
            <li v-for="item in selected" :key="item">
              <div
                class="e-option-badge"
                :title="getOptionText(item)"
                @click="onClickBadge(item)">
                <span>{{ getOptionText(item) }}</span>
                <i class="icon-close"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-else>{{ dictionary.fuelPlaceholder }}</div>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdowLeaseItNowFilterFuel">
      <div class="b-fleet-filters" @click.stop>
        <div class="b-fleet-filters__body">
          <ul>
            <li v-for="item in options" :key="item.value">
              <input
                :id="'fuel' + item.value"
                v-model="selected"
                class="form-check-input"
                autocomplete="off"
                type="checkbox"
                :value="item.value"
                :disabled="item.disabled"
                @change="onChange" />
              <label
                class="form-check-label"
                :for="'fuel' + item.value"
                @click.stop>
                {{ item.text }}
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinsLeaseItNow from './../../mixins/leaseitnow-mixins'
/* eslint-disable no-unused-vars */
import { remove } from 'lodash'
import constants from './../../../lib/constants'
const { filters } = constants.leaseitnow
import { Dropdown } from 'bootstrap'

export default {
  mixins: [mixinsLeaseItNow],
  props: {
    options: {
      required: true,
      type: Array,
    },
  },
  emits: ['change-selected'],
  computed: {
    selected: {
      get: function () {
        return this.options.length ? this.getField(filters.fuels) : []
      },
      set: function (value) {
        this.setField({ field: filters.fuels, value })
        // prettier-ignore
        const args = value.map((x) => this.options.find((i) => i.value === x).apiObject)
        this.setField({ field: `${filters.fuels}Args`, value: args })
      },
    },
  },
  methods: {
    onClickBadge(value) {
      /* eslint-disable no-undef */
      this.selected = _.remove(this.selected, (x) => x !== value)
      this.$emit('change-selected')
      this.dropDownHide()
    },

    getOptionText(value) {
      return this.options.find((i) => i.value === value).text
    },

    onChange() {
      this.$emit('change-selected')
    },

    dropDownHide() {
      document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((i) => {
        new Dropdown(i).hide()
      })
    },
  },
}
</script>
